import * as React from 'react';
import { useEffect, useState } from 'react';
import { ButtonV2, Text } from '@asigna/kit';
import { NoData } from 'components';
import { SendNftDialog } from 'components/Dialog/TransactionDialog/WidthdrawNftDialog/SendNftDialog';
import { SkeletonNftCollection } from 'components/Skeletons/SkeletonAsset';
import { usePermissionWarning, useReadOnlyWarning } from 'hooks';
import useAddress from 'hooks/use-address';
import useNetwork from 'hooks/use-network';
import useSafe from 'hooks/use-safe';
import { isEmpty } from 'lodash';
import { NftSafeState } from 'types/NftTypes';
import { AddressBalance } from 'utils';
import { getNftCollections } from 'utils/nft-tools';

import { useNftImages } from '../../../../store';

import { NftCollectionCard } from './components/NftCollectionDetails/NftCollectionCard/NftCollectionCard';
import { NftCollectionDetails } from './components/NftCollectionDetails/NftCollectionDetails';

type AddressBalancePartial = Pick<AddressBalance, 'non_fungible_tokens'>;

// TODO_R: [FRS]
export const NFTsTab = () => {
  const { safe, nftBalances } = useSafe();
  const walletAccount = useAddress() || '';

  const [balance, setBalance] = useState<AddressBalancePartial | null>(null);

  const [selectedNFTCollectionId, setSelectedNFTCollectionId] = useState<string>('');
  const onAnNFTCollectionDetailsPage = !!selectedNFTCollectionId;
  const [sendNftDialogOpened, setSendNftDialogOpened] = useState<boolean>(false);
  const [selectedCollectionId, setSelectedCollectionId] = useState('');
  const [selectedNFTIds, setSelectedNFTIds] = useState<string[] | null>(null);
  const [nftCollections, setNftCollections] = useState<NftSafeState[]>();
  const [, stacksNetwork] = useNetwork();
  const [isLoading, setIsLoading] = useState(false);
  const readOnlyWarning = useReadOnlyWarning();
  const permissionCreateWarning = usePermissionWarning('PROPOSE');
  const nftImagesStore = useNftImages();

  useEffect(() => {
    const balanceRecord: Record<string, { count: string }> = {};
    nftBalances.forEach((token) => {
      if (token.asset.token) {
        balanceRecord[token.asset.token] = { count: token.balance };
      }
    });

    setBalance({
      non_fungible_tokens: balanceRecord,
    });
  }, [nftBalances]);

  useEffect(
    function loadNFTCollection() {
      setIsLoading(true);
      if (!selectedNFTCollectionId && balance && isEmpty(nftCollections)) {
        getNftCollections(4, walletAccount, safe.address, stacksNetwork, balance, nftImagesStore)
          .then((collection) => setNftCollections(collection))
          .finally(() => setIsLoading(false));
      }
    },
    [balance]
  );

  if (!nftBalances || !balance) return <></>;
  const handleNFTSendClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setSelectedCollectionId('');
    setSelectedNFTIds(null);
    setSendNftDialogOpened(true);
  };
  // const readOnlyWarning = useReadOnlyWarning();

  return (
    <>
      {!onAnNFTCollectionDetailsPage ? (
        <div className="px-0">
          {!!nftCollections?.length && (
            <div className="flex flex-col sm:flex-row gap-8 sm:gap-4 items-start sm:items-center justify-between mb-32">
              <Text message="NFT Collections" size="r20" color="white" />
              <ButtonV2
                onClick={handleNFTSendClick}
                size="md"
                disabled={
                  !!readOnlyWarning ||
                  Boolean(permissionCreateWarning) ||
                  !safe.owners.find((o) => o.address === walletAccount) ||
                  (nftCollections && nftCollections.length === 0)
                }
                disableHint={readOnlyWarning || permissionCreateWarning}
                hintPosition="bottom-end"
                className="min-w-[144px]"
              >
                Send NFT
              </ButtonV2>
            </div>
          )}
          {isLoading ? (
            <SkeletonNftCollection />
          ) : (
            <>{nftCollections?.length === 0 && <NoData isNfts />}</>
          )}
          {nftCollections && nftCollections.length > 0 && !isLoading && (
            <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 flex-wrap gap-24 2xl:gap-32">
              {nftCollections.map((nftCollection) => (
                <NftCollectionCard
                  key={nftCollection.title}
                  setSelectedNFTCollectionId={setSelectedNFTCollectionId}
                  setSelectedCollectionId={setSelectedCollectionId}
                  setSelectedNFTIds={setSelectedNFTIds}
                  nftCollection={nftCollection}
                  balance={balance}
                  setSendNftDialogOpened={setSendNftDialogOpened}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <NftCollectionDetails
          nftCollectionId={selectedNFTCollectionId}
          setSelectedNFTCollectionId={setSelectedNFTCollectionId}
          setSendNftDialogOpened={setSendNftDialogOpened}
          setSelectedNFTIds={setSelectedNFTIds}
          setSelectedCollectionId={setSelectedCollectionId}
          balance={balance}
        />
      )}
      {sendNftDialogOpened && (
        <SendNftDialog
          open={sendNftDialogOpened}
          preselectedCollectionId={selectedCollectionId}
          balance={balance}
          onClose={() => {
            setSendNftDialogOpened(false);
            setSelectedNFTIds(null);
          }}
          preselectedNFTIds={selectedNFTIds}
          // TODO_R: move this prop inside of this component
          selectAllIds={isEmpty(selectedNFTIds)}
        />
      )}
    </>
  );
};
